import { useQuery } from '@tanstack/react-query';
import { getBanksForSelect } from '../../api/apiBanks';

export default function useGetBanksForSelect() {
    const { isLoading, error, data } = useQuery({
        queryKey: ['banksForSelect'],
        queryFn: getBanksForSelect,
    });

    return {
        isLoading,
        error,
        data: data || [],
    };
}
